import {TextField} from "@mui/material";
import type {FormField} from "hooks/useForm";
import type {FC} from "react";

type PhoneInputProps = FormField<string> & {
  size?: "small" | "medium";
};
const PhoneInput: FC<PhoneInputProps> = props => {
  const {value, error, onChange, onBlur, size} = props;

  return (
    <TextField
      label="Phone Number"
      placeholder="e.g., +254123456789"
      value={value}
      onChange={e => onChange(e.target.value)}
      onBlur={onBlur}
      error={!!error}
      helperText={error}
      fullWidth
      margin="normal"
      slotProps={{formHelperText: {sx: {marginLeft: 0}}}}
      size={size}
    />
  );
};
export default PhoneInput;
